import React, { useEffect, useState } from "react";
import FeedCard from "../components/FeedCard";
import { fetchFeed } from "../lib/api";
import { Loader2 } from "lucide-react";

const interleave = (workouts, recipes) => {
    // Shuffle then interleave so workouts and recipes mix nicely
    const w = [...workouts].sort(() => Math.random() - 0.5).map((x) => ({ ...x, _kind: "workout" }));
    const r = [...recipes].sort(() => Math.random() - 0.5).map((x) => ({ ...x, _kind: "recipe" }));
    const out = [];
    const max = Math.max(w.length, r.length);
    for (let i = 0; i < max; i++) {
        if (w[i]) out.push(w[i]);
        if (r[i]) out.push(r[i]);
    }
    return out;
};

const FeedPage = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        fetchFeed()
            .then(({ workouts, recipes }) => {
                if (!mounted) return;
                setItems(interleave(workouts, recipes));
            })
            .catch(() => {})
            .finally(() => mounted && setLoading(false));
        return () => {
            mounted = false;
        };
    }, []);

    if (loading) {
        return (
            <div data-testid="feed-loading" className="h-[100dvh] flex items-center justify-center bg-[#0A0A0A]">
                <Loader2 className="text-[#E1FF01] animate-spin" size={32} />
            </div>
        );
    }

    return (
        <div
            data-testid="feed-page"
            className="h-[100dvh] w-full overflow-y-scroll snap-y snap-mandatory hide-scrollbar"
        >
            {items.map((it) => (
                <FeedCard key={`${it._kind}-${it.id}`} item={it} />
            ))}
        </div>
    );
};

export default FeedPage;
